// eslint-disable-next-line import/prefer-default-export
export const getImageWithFullPath = (image: string) => {
  if (/^http/.test(image)) return image;
  return `https://d1ug1wtffjdh7z.cloudfront.net/${image}`;
};
